module.exports = __webpack_public_path__ + "img/aduana-2.e4ff09bf.svg";